export default "__VITE_ASSET__84ce505b__"